import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/fogVertex.js
var name, shader;
var init_fogVertex = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/ShadersInclude/fogVertex.js"() {
    "use strict";
    init_shaderStore();
    name = "fogVertex";
    shader = `#ifdef FOG
vertexOutputs.vFogDistance=(scene.view*worldPos).xyz;
#endif
`;
    ShaderStore.IncludesShadersStoreWGSL[name] = shader;
  }
});

export {
  init_fogVertex
};
